import { getSelectedProjectId, getAsset } from 'owa-timestream-store';
import getSelectedAssets from './getSelectedAssets';

export default function getSelectedAssetTypes(): Map<string, number> {
    const selectedAssetTypes = new Map();
    const selectedAssets = getSelectedAssets();
    selectedAssets.map(assetId => {
        const asset = getAsset(getSelectedProjectId(), assetId);
        if (selectedAssetTypes.has(asset.type)) {
            selectedAssetTypes.set(asset.type, selectedAssetTypes.get(asset.type) + 1);
        } else {
            selectedAssetTypes.set(asset.type, 1);
        }
    });
    return selectedAssetTypes;
}
